import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export const QUANTIDADE_MAXIMA = 9999999999;

export function criarMonitoramentoConciliacaoForm(fb: FormBuilder): FormGroup {
  return fb.group({
    id: [null],
    anoReferencia: [null, Validators.required],
    mesReferencia: [null, Validators.required],
    quantidadeRequerimentos: [null, [
      Validators.required,
      Validators.min(0),
      Validators.max(QUANTIDADE_MAXIMA),
      Validators.maxLength(10)
    ]],
    quantidadeSessoes: [null, [
      Validators.required,
      Validators.min(0),
      Validators.max(QUANTIDADE_MAXIMA),
      Validators.maxLength(10)
    ]],
    valorTotalAcordos: [null, Validators.required]
  });
}
